<template>
  <vx-card class="mb-6">
    <form ref="form">
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <div class="flex justify-between">
            <label for="" class="vs-input--label"> Site Code <span class="vx-input--asterisk text-danger">*</span>
            </label>
            <span
              v-if="!enableSiteCode"
              class="vs-input--label font-semibold cursor-pointer text-primary"
              @click="enableSiteCode = !enableSiteCode && !isArchivedLocation"
            >
              {{ enableSiteCode ? 'Cancel' : 'Change' }}
            </span>
          </div>
          <vx-field ref="siteCode" type="input" class="w-full" as="siteCode" v-model="form.code" :disabled="!enableSiteCode || isArchivedLocation" required v-validate="{
              required: true,
              ...(defaultCode === form.code
                ? {}
                : {
                    alpha_dash: true,
                    min: 4,
                    max: 20
                  })
            }" />
          <div class="flex justify-between" v-if="$route.params.id">
            <a :target="!isArchivedLocation && '_blank'" class="mt-1 text-link" :href="!isArchivedLocation && `https://${hostname + form.code}`" :disabled="isArchivedLocation">
              <small>Preview Check-in Site</small>
            </a>
            <a :target="!isArchivedLocation && '_blank'" class="mt-1">
              <small class="mt-1 text-link">Preview Kiosks </small>
            </a>
          </div>
          <div class="flex justify-between">
            <span class="mt-1">
              <small>{{ `https://${hostname + form.code}` }}</small>
            </span>
            <span class="mt-1"  v-if="form.devices && form.devices.length>0">

              <span v-for="(q, i) in form.devices" :key="i"><span v-if="i>0"> </br> </span>
                <a :target="!isArchivedLocation && '_blank'" class="mt-1 text-link" :href="!isArchivedLocation && `https://kiosk.${hostname + q.code}`" :disabled="isArchivedLocation">
                <small >{{ `${q.name}` }}</small> 
                </a>
              </span>
            </span>
          </div>
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <div class="tooltip">
            <p> The site code is your unique code for this location and is entered on the URL to access the check-in page for this location </p>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <label class="vs-input--label"> Branding <span class="vx-input--asterisk text-danger">*</span> </label>
          <div class="vs-con-input v-select--questions" v-if="
              !branding.items || (branding.items && branding.items.length === 0)
            ">
            <p> You need to setup your branding before you can create a location. Please <router-link to="/settings">click here</router-link>
            </p>
          </div>
          <v-select name="branding" label="name" v-model="form.branding" :options="branding.items || []" v-validate="'required'" :disabled="isArchivedLocation" />
          <p class="text-sm text-danger mt-1" v-if="errors.has('branding')">{{ errors.first('branding') }}</p>
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4"></div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vx-field type="input" class="w-full" label="Location Name" v-model="form.name" required v-validate="'required'" :disabled="isArchivedLocation" />
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <span class="tooltip">
            <p>e.g. "Head Office", "1 Queen St"</p>
          </span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <div class="vs-component vs-con-input-label vs-input vs-input-primary">
            <label class="vs-input--label">Check in Questions:</label>
            <div class="vs-con-input v-select--questions" v-if="
                questionSetsDataModel &&
                  questionSetsDataModel.items &&
                  questionSetsDataModel.items.length > 0
              ">
              <v-select v-validate="" label="name" name="questionSet" v-model="form.questionSet" :options="questionSetsDataModel.items" :disabled="isArchivedLocation">
                <template v-slot:option="option">
                  <div class="questions-option">
                    <p>
                      <strong>{{ option.name }}</strong>
                    </p>
                    <div class="pl-5" v-if="option.questionSetItems.length > 0">
                      <div v-for="(q, i) in option.questionSetItems" :key="i" class="truncate text-xs flex">
                        <strong>{{ `${i + 1}. ` }}</strong>
                        <div class="ml-2" v-html="q.question.question"></div>
                      </div>
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="
                questionSetsDataModel &&
                  questionSetsDataModel.items &&
                  questionSetsDataModel.items.length === 0
              "> No Questions Sets Entered </div>
          </div>
          <router-link v-if="$route.params.id" class="text-link" :to="{ name: 'settings' }">
            <small>Add/Edit Questions Sets</small>
          </router-link>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vx-field
            type="editor"
            label="Introduction"
            class="w-full"
            v-model="form.introduction"
            :visible="form.introduction !== null"
          >
            <template slot="intro">
              <ul>
                <li>
                  <vs-radio vs-name="radios1" :value="form.introduction" :vs-value="null" @input="value => form.introduction = value" :disabled="isArchivedLocation">Use branding's introduction</vs-radio>
                </li>
                <li>
                  <vs-radio vs-name="radios1" :value="form.introduction !== null ? '' : form.introduction" :vs-value="''" @input="value => form.introduction = value" :disabled="isArchivedLocation">Enter location's own introduction</vs-radio>
                </li>
              </ul>
            </template>
          </vx-field>
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <span class="tooltip"> Text Blurb shown as a Introduction before questions on the Check-in page </span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vx-field
            type="editor"
            label="Privacy Statement"
            class="w-full"
            v-model="form.terms"
            :visible="form.terms !== null"
          >
            <template slot="intro">
              <ul>
                <li>
                  <vs-radio vs-name="radios2" :value="form.terms" :vs-value="null" @input="value => form.terms = value" :disabled="isArchivedLocation">Use branding's privacy statement</vs-radio>
                </li>
                <li>
                  <vs-radio vs-name="radios2" :value="form.terms !== null ? '' : form.terms" :vs-value="''" @input="value => form.terms = value" :disabled="isArchivedLocation">Enter location's own privacy statement</vs-radio>
                </li>
              </ul>
            </template>
          </vx-field>
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <span class="tooltip">Text Blurb shown just before the Submit button on the Check-in Agreements page</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vx-field
            type="editor"
            label="Entry Denied Message"
            class="w-full"
            v-model="form.entryDeniedMessage"
            :visible="form.entryDeniedMessage !== null"
          >
            <template slot="intro">
              <ul>
                <li>
                  <vs-radio vs-name="radios3" :value="form.entryDeniedMessage" :vs-value="null" @input="value => form.entryDeniedMessage = value" :disabled="isArchivedLocation">Use branding's denied message</vs-radio>
                </li>
                <li>
                  <vs-radio vs-name="radios3" :value="form.entryDeniedMessage !== null ? '' : form.entryDeniedMessage" :vs-value="''" @input="value => form.entryDeniedMessage = value" :disabled="isArchivedLocation">Enter location's own denied message</vs-radio>
                </li>
              </ul>
            </template>
          </vx-field>
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <span class="tooltip">This message is shown if a visitor is not allowed onto your site because of their answers to your sign-in
            questions</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vx-field
            type="editor"
            label="Sign In Complete Message"
            class="w-full"
            v-model="form.signInCompleteMessage"
            :visible="form.signInCompleteMessage !== null"
          >
            <template slot="intro">
              <ul>
                <li>
                  <vs-radio vs-name="radios4" :value="form.signInCompleteMessage" :vs-value="null" @input="value => form.signInCompleteMessage = value" :disabled="isArchivedLocation">Use branding's sign in complete message</vs-radio>
                </li>
                <li>
                  <vs-radio vs-name="radios4" :value="form.signInCompleteMessage !== null ? '' : form.signInCompleteMessage" :vs-value="''" @input="value => form.signInCompleteMessage = value" :disabled="isArchivedLocation">Enter location's own sign in complete message</vs-radio>
                </li>
              </ul>
            </template>
          </vx-field>
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <span class="tooltip">This message is shown after a visitor have signed in</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <div class="vx-field relative w-full">
            <vx-field type="number" step=".5" class="w-full" label="Sign In Complete Message Display Time (Seconds)" v-model="form.signInCompleteMessageDisplayTime" :disabled="isArchivedLocation" />
          </div>
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <span class="tooltip">Sign In Complete Message Display Time in Seconds</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <div class="vx-field relative w-full">
            <vx-field type="input" class="w-full" label="Entry Denied Alert Email" v-model="form.entryDeniedEmail" :disabled="isArchivedLocation" />
          </div>
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <span class="tooltip">An email will be sent to this address if visitor is not allowed onto your site because of the answers to your sign-in
            questions.</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vx-field
            type="datetime"
            class="w-full"
            label="Auto Sign Out Time"
            v-model="autoSignoutTime"
            @on-open="handleOnOpen"
            :config="{
              clearable: true,
              altInput: true,
              altFormat: 'G:i K',
              noCalendar: true
            }"
            :disabled="isArchivedLocation"
          />
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <div class="tooltip">
            <p> The time of the day that all visitors to the location will be automatically signed out. Leave blank to disable auto sign out. </p>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vx-field type="v-select" class="w-full" label="Country" :clearable="false" v-model="form.address.country" v-validate="'required'" required
            :options="{
              text: 'name',
              items: $countries || []
            }"
            :disabled="isArchivedLocation"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vx-field type="v-select" autocomplete class="w-full" label="Timezone" :clearable="false" :disabled="!form.address.country || isArchivedLocation" :options="{
              items: tzOptions || []
            }" v-model="form.timezone" v-validate="'required'" required  />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vx-field type="v-select" autocomplete class="w-full" label="QR Code Kiosk Sign In Type" :clearable="false" :disabled="isArchivedLocation" :options="{
              text: 'name',
              items: qrCodeKioskSignInTypeOptions || []
            }" v-model="form.qrCodeKioskSignInType" v-validate="'required'" required  />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vs-alert color="warning">
            <small class="text-xs text-danger">* required fields</small>
          </vs-alert>
        </div>
      </div>
      <div class="vx-row vx-row__actions">
        <div class="vx-col w-full">
          <vs-button class="ml-auto" @click.prevent="saveChanges()" icon-pack="feather" icon="icon-check" icon-before :disabled="isArchivedLocation">Save Changes</vs-button>
        </div>
      </div>
    </form>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select';
import { hostname } from '@/axios.js';
import { mapState, mapGetters } from 'vuex';
import { debounce } from '@/plugins/utils';

export default {
  components: { vSelect },
  props: {
    data: {
      type: Object,
      default() {
        return {
          autoSignoutTime: null,
          branding: {},
          code: '',
          introduction: null,
          name: '',
          terms: null,
          timezone: '',
          address: { country: {} },
          entryDeniedMessage: null,
          signInCompleteMessage: null,
          signInCompleteMessageDisplayTime: 0
        };
      }
    },
    isArchivedLocation: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    const defaultCode = this.data.code;
    if (!this.data.address) {
      this.data.address = {};
    }

    return {
      hostname,
      defaultCode,
      enableSiteCode: false,
      questionSetsDataModel: {
        items: []
      },
      form: {
        ...this.data,
        signInCompleteMessageDisplayTime: this.data.signInCompleteMessageDisplayTime ? this.data.signInCompleteMessageDisplayTime / 1000 : 0,
      },
      qrCodeKioskSignInTypeOptions: [
        {
          "name": "Disabled",
          "value": 0
        },
        {
          "name": "Optional",
          "value": 1
        },
        {
          "name": "Required",
          "value": 2
        }
      ],
    };
  },
  computed: {
    ...mapState('visitManagement', ['branding', 'timezones']),
    ...mapState('auth', ['me']),
    ...mapGetters('auth', ['defaultCountry']),
    tzOptions() {
      console.log("this.$countries >>> ", this.$countries);
      return (this.timezones || []).map(item => {
        if (typeof item === 'string') return item;
        return item.id;
      });
    },
    autoSignoutTime: {
      get() {
        try {
          return this.$moment()
            .startOf('day')
            .minutes(this.form.autoSignoutTime)
            .utc()
            .format();
        } catch (error) {
          return null;
        }
      },
      set: debounce(function (value) {
        console.log(value)
        this.form.autoSignoutTime = !value
          ? null
          : this.$moment(
            value,
            'DD-MM-YYYY HH:mm'
          ).diff(this.$moment().startOf('day'), 'minutes');
      }, 250)
    }
  },
  methods: {
    handleOnOpen(dates, value, component) {
      this.autoSignoutTime = value ? value : `${this.$moment().format('DD-MM-YYYY')} 12:00`;
    },
    saveChanges() {
      const {
        form,
        $validator,
        $store,
        $vs,
        $nextTick,
        $autoFocusOnFirstError,
        errors,
        $refs,
        $route,
        $router
      } = this;
      $validator.validateAll().then(async isValid => {
        if (isValid) {
          console.log("this.form >>> ", this.form);
          const result = await $store
            .dispatch('visitManagement/updateLocation', {
              id: form.id,
              ...(form.questionSet
                ? {
                  questionSet: { id: form.questionSet.id }
                }
                : {}),
              introduction: form.introduction,
              terms: form.terms,
              name: form.name,
              mobile: form.mobile,
              code: (form.code || '').trim(),
              branding: form.branding,
              autoSignoutTime: form.autoSignoutTime,
              address: form.address || {},
              timezone: form.timezone,
              entryDeniedMessage: form.entryDeniedMessage,
              entryDeniedEmail: form.entryDeniedEmail,
              signInCompleteMessage: form.signInCompleteMessage,
              signInCompleteMessageDisplayTime: parseFloat(form.signInCompleteMessageDisplayTime) * 1000,
              qrCodeKioskSignInType: form.qrCodeKioskSignInType.value,
            })
            .then(res => {
              const { query, params } = $route;
              if (query.redirect) return $router.push(query.redirect);
              if (!params.id) {
                return $router.push({
                  name: 'edit-location',
                  params: { id: res.data.id }
                });
              }
              $vs.notify({
                color: 'success',
                title: 'Location Updated',
                text: res.data.message
              });
              return res.data;
            })
            .catch(error => {
              console.error(error);
              const { response } = error;
              if (response) {
                const { data, status } = response;
                if (status === 406 || data.code === 'unique_code') {
                  const { siteCode } = $refs;
                  if (!this.enableSiteCode) this.enableSiteCode = true;
                  this.$nextTick(() => {
                    siteCode.$refs.vsInput.$refs.vsinput.scrollIntoView(false);
                    siteCode.$refs.vsInput.$refs.vsinput.focus();
                  });
                }
              }
            });

          this.$emit('success', result);
        }
        $nextTick(() => {
          $autoFocusOnFirstError(errors);
          console.log((window.$ctrl = this));
        });
      });
    },
    async setDefaultCountry() {
      const { $store, defaultCountry, $countries } = this;
      if (defaultCountry) {
        this.form.address.country = $countries.find(
          item => item.name === defaultCountry
        );
      } else {
        const result = await $store.dispatch('auth/clientStack');
        if (result) {
          const country = $countries.find(
            item => item.countryCode === result.loc
          );
          if (country) this.form.address.country = country;
        }
      }
    }
  },
  async created() {
    console.log("this.form >>> ", this.form);
    await this.$store.dispatch('visitManagement/fetchBranding', { limit: 200,archived:false });
    this.questionSetsDataModel = await this.$store.dispatch(
      'visitManagement/fetchQuestionSets', { limit: 200 }
    );

    var address = (this.form || {}).address;
    var qrCodeKioskSignInType = (this.form || {}).qrCodeKioskSignInType;
    if (qrCodeKioskSignInType !== null || qrCodeKioskSignInType !== undefined) {
      qrCodeKioskSignInType = this.qrCodeKioskSignInTypeOptions.filter(data => data.value === qrCodeKioskSignInType);
      console.log("qrCodeKioskSignInType >>> ", qrCodeKioskSignInType);
      this.form.qrCodeKioskSignInType = qrCodeKioskSignInType;
    }

    if (!this.$route.params.id) {
      await this.setDefaultCountry();
      this.form.entryDeniedEmail = this.me.tenant.email;
      if (((this.branding || {}).items || [])[0])
        this.form.branding = this.branding.items[0];
      if (((this.questionSetsDataModel || {}).items || [])[0])
        this.form.questionSet = this.questionSetsDataModel.items[0];
    } else if (address && address.country) {
      await this.$store.dispatch(
        'visitManagement/timezones',
        this.form.address.country.countryCode
      );
    }
  },
  watch: {
    async 'form.address.country'(obj, oldObj) {
      if (typeof obj === 'string') return;
      if (obj && obj.countryCode !== (oldObj || {}).countryCode) {
        const result = await this.$store.dispatch(
          'visitManagement/timezones',
          obj.countryCode
        );
        if (result.length > 0) this.form.timezone = result[0];
      }
    }
  }
};
</script>
